import { atom } from 'nanostores';

/**
 * Public feature flags the signup funnel depends on. These resolve for
 * anonymous visitors through the unauthenticated `public_feature_flags`
 * endpoint — account flags can't apply pre-auth.
 */
export const SignupPublicFeatureFlag = {
  /** Renders the funnel in the dark theme. */
  SignupDarkMode: 'signup_dark_mode',
  /**
   * Enables the startup-program signup variant (`?signupType=startup`).
   * When unresolved or off, a startup signup downgrades to `journeys`.
   */
  SignupStartupForm: 'signup_startup_form',
} as const;

export type SignupPublicFeatureFlag = (typeof SignupPublicFeatureFlag)[keyof typeof SignupPublicFeatureFlag];

/** `null` = the public-flags fetch hasn't settled; an object = settled (a failed fetch settles to `{}`). */
export type SignupPublicFlags = Record<string, boolean> | null;

export const signupPublicFlagsStore = atom<SignupPublicFlags>(null);

export function hasSignupPublicFlag(flags: SignupPublicFlags, flag: SignupPublicFeatureFlag): boolean {
  return flags?.[flag] === true;
}
